// This icon file is generated automatically.
var PtoArrArrowrIghtOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 32 32", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M27.16 15.24L15.35 5a.5.5 0 00-.33-.13h-2.76a.25.25 0 00-.17.44l10.95 9.5H4.75a.25.25 0 00-.25.25v1.88c0 .13.11.25.25.25h18.28l-10.94 9.5a.25.25 0 00.16.43h2.86c.06 0 .12-.02.17-.06l11.88-10.3a1 1 0 000-1.52z", "fill-rule": "nonzero" } }] }, "name": "pto-arr-arrowr-ight", "theme": "outlined" };
export default PtoArrArrowrIghtOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PtoArrArrowrIghtOutlined.js
// module id = 3871
// module chunks = 0